import React from "react";
import { toast } from "react-hot-toast";
import { apiConnector } from "../api/client";
import { catalogData } from "../api/endpoints";

export const getCatalogaPageData = async (categoryId) => {
  const toastId = toast.loading("Loading...");
  let result = [];
  try {
    // Updated to use GET with dynamic categoryId parameter
    const response = await apiConnector(
      "GET",
      `${catalogData.CATALOGPAGEDATA_API}/${categoryId}`
    );

    if (!response?.data?.success)
      throw new Error("Could not Fetch Category page data");

    result = response?.data;
  } catch (error) {
    console.log("CATALOG PAGE DATA API ERROR....", error);
    toast.error(error.message);
    result = error.response?.data;
  }
  toast.dismiss(toastId);
  return result;
};
